// import css
import '../static/froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from '../static/froala-editor/js/froala_editor.pkgd.min.js';

// import themes
import '../static/froala-editor/css/themes/dark.min.css';
import '../static/froala-editor/css/themes/gray.min.css';
import '../static/froala-editor/css/themes/royal.min.css';

// TODO move to own file
window.FroalaEditor = FroalaEditor;
window.Grape.froala = {
	key: 'aLF3c1A7C7D6A2B2A2G2xROKLJKYHROLDXDRH1e1YYGRe1Bg1G3I3A2A4D6A3F3E4D2G2==',
	toolbarButtons: [
		[
			'fullscreen',
			'undo',
			'redo',
			'getPDF',
			'print'
		],
		[
			'bold',
			'italic',
			'underline',
			'textColor',
			'backgroundColor',
			'clearFormatting'
		],
		[
			'alignLeft',
			'alignCenter',
			'alignRight',
			'alignJustify'
		],
		[
			'formatOL',
			'formatUL',
			'indent',
			'outdent'
		],
		[
			'paragraphFormat'
		],
		[
			'fontFamily'
		],
		[
			'fontSize'
		],
		[
			'insertLink',
			'insertImage',
			'insertFile',
			'quote',
			'table',
			'html'
		]
	],
	compactToolbarButtons: {
		'moreText': {
			'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
		},
		'moreParagraph': {
			'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
		},
		'moreRich': {
			'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR']
		},
		'moreElements': {
			'buttons': ['insertAnchorBtn', 'insertContainer', 'insertBtn']
		},
		'moreMisc': {
			'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help']
		}
	}
};

// import js
import components from './components/index.js';
import plugins from './plugins/index.js';
import package_json from '../package.json';


// import froala plugins
// import '../static/froala-editor/css/third_party/font_awesome.min.css';
// import '../static/froala-editor/js/third_party/font_awesome.min';

(function() {

	window.Grape.modules.push(package_json);

	Grape.component.registerComponents(components);
	Grape.plugins.registerPlugins(plugins);
})();
